import { DineroObject } from "dinero.js";

export const MIN_US_TRANSFER_OBJECT: DineroObject = {
  amount: 2500,
  currency: "USD",
  precision: 2,
};

export const MIN_INTL_TRANSFER_OBJECT: DineroObject = {
  amount: 2500,
  currency: "USD",
  precision: 2,
};
